import { appSettingsSchemas, appSettingsPaths, LifecycleJobSchema } from "./app-settings";
export * from "./app-settings";
export * from "./task-icons";
import {
  TaskIconJobSchema,
  TaskIconIdSchema,
  TaskIconResolutionSchema,
  TaskIconResolveRequestSchema,
  TaskIconResolveResponseSchema,
} from "./task-icons";
import { nativeSchemas, nativePaths } from "./native";
export * from "./native";
import {
  DailySummaryDeliveryJobSchema,
  DailySummarySchema,
  DailySummaryResponseSchema,
  DailySummarySettingsInputSchema,
  DailySummarySettingsResponseSchema,
  DailySummaryEmailRequestSchema,
  DailySummaryEmailConfirmSchema,
} from "./daily-summary";
export * from "./daily-summary";
import { z } from "zod";
import {
  BrowserSessionResponseSchema,
  ChildSessionRenewResponseSchema,
  ChildEnrollmentCreateRequestSchema,
  ChildEnrollmentCreateResponseSchema,
  ChildEnrollmentRedeemRequestSchema,
  DeviceListResponseSchema,
  DeviceRevokeRequestSchema,
  UpdateDeviceLabelRequestSchema,
  PasskeyCredentialSchema,
  PasskeyCredentialListResponseSchema,
  UpdatePasskeyCredentialRequestSchema,
  WorkspaceMembershipSchema,
  WorkspaceMembershipListResponseSchema,
  WorkspaceMembershipResponseSchema,
  CreateMembershipInvitationRequestSchema,
  CreateMembershipInvitationResponseSchema,
  InspectMembershipInvitationRequestSchema,
  InspectMembershipInvitationResponseSchema,
  InvitationPasskeyRegistrationOptionsRequestSchema,
  MembershipInvitationSchema,
  MembershipInvitationScopeSchema,
  MembershipScopeSchema,
  MembershipInvitationListResponseSchema,
  RevokeMembershipInvitationRequestSchema,
  SupporterCapabilitySchema,
  UpdateWorkspaceMembershipRequestSchema,
  TransferWorkspaceOwnershipRequestSchema,
  LeaveWorkspaceRequestSchema,
  WorkspaceSettingsSchema,
  UpdateWorkspaceSettingsRequestSchema,
  WorkspaceSettingsResponseSchema,
  PasskeyAuthenticationOptionsRequestSchema,
  PasskeyAuthenticationVerifyRequestSchema,
  PasskeyOptionsResponseSchema,
  PasskeyRegistrationOptionsRequestSchema,
  PasskeyRegistrationVerifyRequestSchema,
  RecoveryLoginRequestSchema,
  SuccessResponseSchema,
  WebAuthnCredentialResponseSchema,
  WorkspaceSummarySchema,
  AuthenticatedActorSchema,
  DeviceSchema,
} from "./identity";
import {
  BackgroundJobResponseSchema,
  StagingRuntimeProofRequestSchema,
  StagingRuntimeProofResponseSchema,
} from "./operations";
import {
  CreateWorkspaceExportRequestSchema,
  DeleteWorkspaceExportRequestSchema,
  WorkspaceExportListResponseSchema,
  WorkspaceExportResponseSchema,
} from "./data-administration";
import {
  BacklogTaskListResponseSchema,
  CarryoverTaskListResponseSchema,
  CarryoverTaskSchema,
  CreateAssignedTaskRequestSchema,
  CreateAssignedTaskResponseSchema,
  CreateMilestoneRequestSchema,
  CreateMilestoneResponseSchema,
  CreateProjectRequestSchema,
  CreateProjectResponseSchema,
  ProjectListResponseSchema,
  ProjectSchema,
  MilestoneCommandRequestSchema,
  MilestoneCommandResponseSchema,
  MilestoneSchema,
  TaskCommandRequestSchema,
  TaskCommandResponseSchema,
  RescheduleTaskRequestSchema,
  RescheduleTaskResponseSchema,
  TaskListResponseSchema,
  ScheduledTaskSchema,
  TodayTaskListResponseSchema,
  TodayTaskReorderRequestSchema,
  TodayTaskReorderResponseSchema,
  TodayTaskSchema,
  UpdateTaskRequestSchema,
  UpdateTaskResponseSchema,
  UpdateProjectRequestSchema,
  UpdateProjectResponseSchema,
  ProjectArchiveCommandRequestSchema,
  ProjectArchiveCommandResponseSchema,
} from "./planning";
import {
  AgentGrantListResponseSchema,
  AgentGrantRevokeRequestSchema,
  AgentGrantSchema,
  McpActorResponseSchema,
  McpToolAuditRequestSchema,
  McpResourceAuditRequestSchema,
  McpBulkReschedulePreviewRequestSchema,
  McpBulkReschedulePreviewResponseSchema,
  McpBulkRescheduleApplyRequestSchema,
  McpBulkRescheduleApplyResponseSchema,
  OAuthAuthorizationRequestCreateResponseSchema,
  OAuthAuthorizationRequestCreateSchema,
  OAuthClientRegistrationRequestSchema,
  OAuthClientRegistrationResponseSchema,
  OAuthConsentApproveRequestSchema,
  OAuthConsentApproveResponseSchema,
  OAuthConsentRequestSchema,
  OAuthConsentResponseSchema,
  OAuthTokenResponseSchema,
} from "./mcp";
import {
  CancelInboxItemRequestSchema,
  CancelInboxItemResponseSchema,
  CreateInboxItemRequestSchema,
  CreateInboxItemResponseSchema,
  InboxItemListResponseSchema,
  InboxItemSchema,
  PlanInboxItemRequestSchema,
  PlanInboxItemResponseSchema,
} from "./inbox";
import {
  RoutineSchema,
  RoutineListResponseSchema,
  RoutineReconciliationListResponseSchema,
  RoutineReconciliationRequestSchema,
  RoutineReconciliationResponseSchema,
  RoutineCreatePreviewRequestSchema,
  RoutineCreatePreviewResponseSchema,
  RoutineCreateApplyRequestSchema,
  RoutineCreateApplyResponseSchema,
  RoutineVersionHistoryResponseSchema,
  RoutineVersionComparisonResponseSchema,
  RoutineStatusCommandRequestSchema,
  RoutineStatusCommandResponseSchema,
  RoutineUpdatePreviewRequestSchema,
  RoutineUpdatePreviewResponseSchema,
  RoutineUpdateApplyRequestSchema,
  RoutineUpdateApplyResponseSchema,
} from "./routines";
import {
  CreateRoutineTemplateRequestSchema,
  RoutineTemplateArchiveCommandRequestSchema,
  RoutineTemplateArchiveCommandResponseSchema,
  RoutineTemplateListResponseSchema,
  RoutineTemplateMutationResponseSchema,
  RoutineTemplateSchema,
  UpdateRoutineTemplateRequestSchema,
} from "./routine-templates";
import {
  AreaArchiveCommandRequestSchema,
  AreaArchiveCommandResponseSchema,
  AreaListResponseSchema,
  AreaMutationResponseSchema,
  AreaReorderRequestSchema,
  AreaReorderResponseSchema,
  AreaSchema,
  CreateAreaRequestSchema,
  CreateTermRequestSchema,
  TermArchiveCommandRequestSchema,
  TermArchiveCommandResponseSchema,
  TermListResponseSchema,
  TermMutationResponseSchema,
  TermSchema,
  UpdateAreaRequestSchema,
  UpdateTermRequestSchema,
} from "./organization";
import {
  ApplyReviewActionRequestSchema,
  ChildCurrentFamilyCycleResponseSchema,
  ChildCurrentFamilyCycleSchema,
  ChildCycleCommitmentSchema,
  CreateFamilyCycleRequestSchema,
  DismissReviewActionRequestSchema,
  FamilyCycleCommandRequestSchema,
  FamilyCycleCommandResponseSchema,
  FamilyCycleListResponseSchema,
  FamilyCycleMutationResponseSchema,
  FamilyCycleResponseSchema,
  FamilyCycleSchema,
  ReviewActionCommandResponseSchema,
  UpdateFamilyCyclePlanRequestSchema,
  UpdateFamilyCycleReviewRequestSchema,
} from "./cycles";
import {
  CreateTaskChecklistItemRequestSchema,
  CreateTaskDependencyRequestSchema,
  OverrideTaskDependencyRequestSchema,
  RemoveTaskDependencyRequestSchema,
  TaskChecklistItemCommandRequestSchema,
  TaskChecklistItemMutationResponseSchema,
  TaskChecklistItemSchema,
  TaskDependencyMutationResponseSchema,
  TaskDependencySchema,
  TaskStructureResponseSchema,
  TaskStructureSchema,
  UpdateTaskChecklistItemRequestSchema,
} from "./task-structure";
import {
  CreateWorkspaceCalendarRequestSchema,
  UpdateWorkspaceCalendarRequestSchema,
  WorkspaceCalendarArchiveCommandRequestSchema,
  WorkspaceCalendarArchiveCommandResponseSchema,
  WorkspaceCalendarListResponseSchema,
  WorkspaceCalendarMutationResponseSchema,
  WorkspaceCalendarSchema,
} from "./calendars";
import {
  NotificationCommandResponseSchema,
  NotificationListResponseSchema,
  NotificationPreferenceInputSchema,
  NotificationPreferenceListResponseSchema,
  NotificationPreferenceMutationResponseSchema,
  NotificationPreferenceSchema,
  NotificationReadCommandRequestSchema,
  NotificationSchema,
  NotificationSnoozeCommandRequestSchema,
} from "./notifications";
import {
  WebPushConfigResponseSchema,
  WebPushSubscriptionDeleteRequestSchema,
  WebPushSubscriptionInputSchema,
  WebPushSubscriptionResponseSchema,
  WebPushSubscriptionSchema,
} from "./web-push";
import {
  CreateEvidenceUploadRequestSchema,
  CreateNoteEvidenceRequestSchema,
  DeleteEvidenceRequestSchema,
  EvidenceAccessRequestSchema,
  EvidenceAccessResponseSchema,
  EvidenceListResponseSchema,
  EvidenceMutationResponseSchema,
  EvidenceObjectUploadResponseSchema,
  EvidenceSchema,
  EvidenceUploadReservationResponseSchema,
  EvidenceUploadSchema,
  FinalizeEvidenceUploadRequestSchema,
} from "./evidence";
import {
  DashboardDailyLoadSchema,
  DashboardHighlightSchema,
  DashboardProjectProgressSchema,
  DashboardRateSchema,
  DashboardResponseSchema,
  DashboardRoutineTrendSchema,
  DashboardTaskBreakdownSchema,
  DashboardTermProgressSchema,
} from "./insights";
import {
  ProductHistoryItemSchema,
  ProductHistoryPageResponseSchema,
  SearchContentItemSchema,
  SearchContentPageResponseSchema,
  SecurityAuditItemSchema,
  SecurityAuditPageResponseSchema,
} from "./search-history";

export * from "./identity";
export * from "./inbox";
export * from "./routines";
export * from "./routine-templates";
export * from "./mcp";
export * from "./operations";
export * from "./planning";
export * from "./organization";
export * from "./cycles";
export * from "./task-structure";
export * from "./calendars";
export * from "./notifications";
export * from "./web-push";
export * from "./evidence";
export * from "./insights";
export * from "./search-history";
export * from "./data-administration";

const RequestIdSchema = z.string().regex(/^req_[0-9a-f-]{36}$/u);
const OpaqueIdSchema = z.uuid();

export const ErrorEnvelopeSchema = z
  .object({
    error: z
      .object({
        code: z.string().regex(/^[A-Z][A-Z0-9_]+$/u),
        message: z.string().min(1).max(240),
        request_id: RequestIdSchema,
        details: z.record(z.string(), z.string()).optional(),
      })
      .strict(),
  })
  .strict();

export const HealthResponseSchema = z
  .object({
    status: z.literal("ok"),
    service: z.string().min(1),
    environment: z.enum(["local", "staging", "production"]),
    deployment_version: z.string().min(1),
    request_id: RequestIdSchema,
  })
  .strict();

export const DependencyStatusSchema = z
  .object({
    d1: z.enum(["ready", "unavailable"]),
    r2: z.enum(["ready", "unavailable"]),
    queue: z.enum(["configured", "unavailable"]),
    workflow: z.enum(["configured", "not_required", "unavailable"]),
    durable_object: z.enum(["configured", "not_required", "unavailable"]),
    auth_config: z.enum(["ready", "not_required", "unavailable"]),
  })
  .strict();

export const ReadinessResponseSchema = z
  .object({
    status: z.enum(["ready", "not_ready"]),
    migration_head: z.literal("0032"),
    dependencies: DependencyStatusSchema,
    request_id: RequestIdSchema,
  })
  .strict();

export const MeResponseSchema = z
  .object({
    actor: z
      .object({
        id: OpaqueIdSchema,
        type: z.enum(["adult", "child"]),
        workspace_id: OpaqueIdSchema,
        membership_role: z.enum(["owner", "guardian", "supporter"]).nullable(),
        bound_child_id: OpaqueIdSchema.nullable(),
        device_id: OpaqueIdSchema,
        session_id: OpaqueIdSchema,
        capabilities: z.array(
          z.enum(["today:read", "tasks:start", "tasks:complete", "tasks:help", "tasks:reorder"]),
        ),
        membership_scopes: z.array(MembershipScopeSchema).max(100),
        authentication_method: z.enum([
          "passkey",
          "recovery_code",
          "child_enrollment",
          "test_fixture",
        ]),
      })
      .strict(),
    workspace: WorkspaceSummarySchema,
    request_id: RequestIdSchema,
  })
  .strict();

export const ChildProfileSchema = z
  .object({
    id: OpaqueIdSchema,
    workspace_id: OpaqueIdSchema,
    display_name: z.string().min(1).max(80),
    theme_color: z.string().regex(/^#[0-9a-f]{6}$/u),
    reading_level: z.enum(["emergent", "beginner", "independent"]),
    display_density: z.enum(["comfortable", "compact"]),
    version: z.number().int().positive(),
    created_at: z.iso.datetime({ offset: true }),
    updated_at: z.iso.datetime({ offset: true }),
    archived_at: z.iso.datetime({ offset: true }).nullable(),
  })
  .strict();

export const CreateChildProfileRequestSchema = z
  .object({
    display_name: z.string().trim().min(1).max(80),
    theme_color: z.string().regex(/^#[0-9a-fA-F]{6}$/u),
    reading_level: z.enum(["emergent", "beginner", "independent"]),
    display_density: z.enum(["comfortable", "compact"]),
  })
  .strict();

export const CreateChildProfileResponseSchema = z
  .object({
    child: ChildProfileSchema,
    sync_cursor: z.string().min(1),
    request_id: RequestIdSchema,
  })
  .strict();

export const UpdateChildProfileRequestSchema = CreateChildProfileRequestSchema.extend({
  version: z.number().int().positive(),
}).strict();

export const ChildProfileVersionRequestSchema = z
  .object({ version: z.number().int().positive() })
  .strict();

export const ChildProfileResponseSchema = z
  .object({
    child: ChildProfileSchema,
    sync_cursor: z.string().min(1),
    request_id: RequestIdSchema,
  })
  .strict();

export const ChildProfilePageSchema = z
  .object({
    items: z.array(ChildProfileSchema),
    next_cursor: z.string().nullable(),
    request_id: RequestIdSchema,
  })
  .strict();

export const FoundationJobSchema = z
  .object({
    job_id: OpaqueIdSchema,
    workspace_id: OpaqueIdSchema,
    type: z.literal("foundation.queue.proof"),
    schema_version: z.literal(1),
    created_at: z.number().int().nonnegative(),
    idempotency_key: z.string().min(8).max(200),
    value: z.string().min(1).max(200),
  })
  .strict();

export const RoutineReconciliationJobSchema = z
  .object({
    job_id: OpaqueIdSchema,
    workspace_id: OpaqueIdSchema,
    type: z.literal("routine.reconcile"),
    schema_version: z.literal(1),
    created_at: z.number().int().nonnegative(),
    idempotency_key: z.string().min(8).max(200),
    reconciliation_run_id: OpaqueIdSchema,
    scheduled_at: z.number().int().nonnegative(),
    window_days: z.number().int().min(7).max(31).default(14),
  })
  .strict();

export const WebPushDeliveryJobSchema = z
  .object({
    job_id: OpaqueIdSchema,
    workspace_id: OpaqueIdSchema,
    type: z.literal("notification.web_push.deliver"),
    schema_version: z.literal(1),
    created_at: z.number().int().nonnegative(),
    idempotency_key: z.string().min(8).max(200),
    dispatch_id: OpaqueIdSchema,
  })
  .strict();

export const NativePushDispatchJobSchema = z
  .object({
    job_id: OpaqueIdSchema,
    workspace_id: OpaqueIdSchema,
    type: z.literal("notification.native_push.dispatch"),
    schema_version: z.literal(1),
    created_at: z.number().int().nonnegative(),
    idempotency_key: z.string().min(8).max(200),
    task_id: OpaqueIdSchema,
  })
  .strict();

export const JobsQueueMessageSchema = z.discriminatedUnion("type", [
  FoundationJobSchema,
  RoutineReconciliationJobSchema,
  WebPushDeliveryJobSchema,
  NativePushDispatchJobSchema,
  DailySummaryDeliveryJobSchema,
  TaskIconJobSchema,
  LifecycleJobSchema,
]);

export const WorkflowParamsSchema = z
  .object({
    job_id: OpaqueIdSchema,
    workspace_id: OpaqueIdSchema,
    idempotency_key: z.string().min(8).max(200),
    value: z.string().min(1).max(200),
  })
  .strict();

export const RoutineMaterializationWorkflowParamsSchema = z
  .object({
    job_id: OpaqueIdSchema,
    workspace_id: OpaqueIdSchema,
    idempotency_key: z.string().min(8).max(200),
    scheduled_at: z.number().int().nonnegative(),
    window_days: z.number().int().min(7).max(62).default(42),
    reconciliation_run_id: OpaqueIdSchema.nullable().default(null),
    reconciliation_window_days: z.number().int().min(7).max(31).nullable().default(null),
  })
  .strict()
  .refine(
    (value) =>
      (value.reconciliation_run_id === null && value.reconciliation_window_days === null) ||
      (value.reconciliation_run_id !== null && value.reconciliation_window_days !== null),
    { message: "reconciliation run and window must be provided together" },
  );

export const RealtimeClientMessageSchema = z
  .object({
    type: z.literal("ping"),
    cursor: z.number().int().nonnegative(),
  })
  .strict();

export type ErrorEnvelope = z.infer<typeof ErrorEnvelopeSchema>;
export type CreateChildProfileRequest = z.infer<typeof CreateChildProfileRequestSchema>;
export type ChildProfile = z.infer<typeof ChildProfileSchema>;
export type FoundationJob = z.infer<typeof FoundationJobSchema>;
export type RoutineReconciliationJob = z.infer<typeof RoutineReconciliationJobSchema>;
export type WebPushDeliveryJob = z.infer<typeof WebPushDeliveryJobSchema>;
export type JobsQueueMessage = z.infer<typeof JobsQueueMessageSchema>;
export type WorkflowParams = z.infer<typeof WorkflowParamsSchema>;
export type RoutineMaterializationWorkflowParams = z.infer<
  typeof RoutineMaterializationWorkflowParamsSchema
>;

function jsonSchema(schema: z.ZodType): Record<string, unknown> {
  const generated = z.toJSONSchema(schema, { target: "draft-2020-12" }) as Record<string, unknown>;
  delete generated.$schema;
  return toOpenApi30Schema(generated) as Record<string, unknown>;
}

function toOpenApi30Schema(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(toOpenApi30Schema);
  if (typeof value !== "object" || value === null) return value;

  const source = value as Record<string, unknown>;
  const nullableOptions = Array.isArray(source.anyOf)
    ? source.anyOf.filter(
        (option) =>
          typeof option !== "object" ||
          option === null ||
          (option as Record<string, unknown>).type !== "null",
      )
    : null;
  const hasNullOption =
    Array.isArray(source.anyOf) &&
    nullableOptions !== null &&
    nullableOptions.length !== source.anyOf.length;
  if (hasNullOption && nullableOptions.length === 1) {
    const converted = toOpenApi30Schema(nullableOptions[0]);
    if (typeof converted === "object" && converted !== null && !Array.isArray(converted)) {
      return { ...(converted as Record<string, unknown>), nullable: true };
    }
  }

  const converted: Record<string, unknown> = {};
  for (const [key, child] of Object.entries(source)) {
    if (key === "$schema") continue;
    if (key === "const") {
      converted.enum = [child];
      continue;
    }
    if (key === "exclusiveMinimum" && typeof child === "number") {
      converted.minimum = child;
      converted.exclusiveMinimum = true;
      continue;
    }
    if (key === "exclusiveMaximum" && typeof child === "number") {
      converted.maximum = child;
      converted.exclusiveMaximum = true;
      continue;
    }
    converted[key] = toOpenApi30Schema(child);
  }
  return converted;
}

function jsonResponse(schemaReference: string, description: string): Record<string, unknown> {
  return {
    description,
    content: {
      "application/json": { schema: { $ref: `#/components/schemas/${schemaReference}` } },
    },
  };
}

const errorResponses = {
  "400": jsonResponse("ErrorEnvelope", "Invalid request"),
  "401": jsonResponse("ErrorEnvelope", "Authentication required or expired"),
  "403": jsonResponse("ErrorEnvelope", "Authenticated actor lacks the capability"),
  "404": jsonResponse("ErrorEnvelope", "Resource absent or concealed across tenants"),
  "409": jsonResponse("ErrorEnvelope", "Idempotency or state conflict"),
  "413": jsonResponse("ErrorEnvelope", "Request body too large"),
  "422": jsonResponse("ErrorEnvelope", "Domain rule rejected the request"),
  "429": jsonResponse("ErrorEnvelope", "Rate limit exceeded"),
  "503": jsonResponse("ErrorEnvelope", "A required dependency is unavailable"),
};

export function buildOpenApiDocument(): Record<string, unknown> {
  return {
    openapi: "3.0.3",
    info: {
      title: "Oyako Flow Core API",
      version: "0.1.0",
      description:
        "Authoritative, versioned Core API shared by the Web/PWA, future native clients, WebMCP and Remote MCP adapters.",
    },
    servers: [
      { url: "http://127.0.0.1:8790", description: "Local Cloudflare runtime" },
      {
        url: "https://oyako-flow-web-staging.stripes-rainier0g3920.workers.dev",
        description: "Cloudflare staging through the same-origin web gateway",
      },
    ],
    tags: [
      { name: "operations", description: "Liveness and dependency readiness" },
      { name: "identity", description: "Authenticated actor context" },
      { name: "family", description: "Workspace-scoped family resources" },
      { name: "inbox", description: "Untriaged capture and planning handoff" },
      { name: "planning", description: "Planning, Today, and task commands" },
      { name: "routines", description: "Versioned recurrence and Task materialization" },
      { name: "notifications", description: "Durable family notification inbox and state" },
      {
        name: "search-history",
        description: "Workspace content search, product history, and separated security audit",
      },
      {
        name: "data-administration",
        description: "Recent-auth portable export and private artifact lifecycle",
      },
      { name: "mcp", description: "Remote MCP OAuth, actor context, and audited access" },
      { name: "realtime", description: "Authenticated Workspace invalidation channel" },
      { name: "staging-operations", description: "Owner-only staging runtime verification" },
    ],
    paths: {
      ...nativePaths(),
      ...appSettingsPaths(),
      "/healthz": {
        get: {
          operationId: "getHealth",
          tags: ["operations"],
          responses: { "200": jsonResponse("HealthResponse", "Worker is alive") },
        },
      },
      "/openapi.json": {
        get: {
          operationId: "getOpenApiDocument",
          tags: ["operations"],
          responses: {
            "200": {
              description: "Current Core API OpenAPI document",
              content: { "application/json": { schema: { type: "object" } } },
            },
          },
        },
      },
      "/readyz": {
        get: {
          operationId: "getReadiness",
          tags: ["operations"],
          responses: {
            "200": jsonResponse("ReadinessResponse", "All required dependencies are ready"),
            "503": jsonResponse(
              "ReadinessResponse",
              "At least one required dependency is unavailable",
            ),
          },
        },
      },
      "/api/v1/auth/passkeys/register/options": {
        post: {
          operationId: "createPasskeyRegistrationOptions",
          tags: ["identity"],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/PasskeyRegistrationOptionsRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("PasskeyOptionsResponse", "Passkey registration options"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/auth/passkeys/register/verify": {
        post: {
          operationId: "verifyPasskeyRegistration",
          tags: ["identity"],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/PasskeyRegistrationVerifyRequest" },
              },
            },
          },
          responses: {
            "201": jsonResponse("BrowserSessionResponse", "Family and passkey created"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/auth/passkeys/login/options": {
        post: {
          operationId: "createPasskeyAuthenticationOptions",
          tags: ["identity"],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/PasskeyAuthenticationOptionsRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("PasskeyOptionsResponse", "Passkey authentication options"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/auth/passkeys/login/verify": {
        post: {
          operationId: "verifyPasskeyAuthentication",
          tags: ["identity"],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/PasskeyAuthenticationVerifyRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("BrowserSessionResponse", "Authenticated browser session"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/auth/membership-invitations/inspect": {
        post: {
          operationId: "inspectMembershipInvitation",
          tags: ["identity"],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/InspectMembershipInvitationRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse(
              "InspectMembershipInvitationResponse",
              "One-time invitation details",
            ),
            ...errorResponses,
          },
        },
      },
      "/api/v1/auth/membership-invitations/register/options": {
        post: {
          operationId: "createInvitationPasskeyRegistrationOptions",
          tags: ["identity"],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/InvitationPasskeyRegistrationOptionsRequest",
                },
              },
            },
          },
          responses: {
            "200": jsonResponse("PasskeyOptionsResponse", "Invitation passkey options"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/auth/membership-invitations/register/verify": {
        post: {
          operationId: "verifyInvitationPasskeyRegistration",
          tags: ["identity"],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/PasskeyRegistrationVerifyRequest" },
              },
            },
          },
          responses: {
            "201": jsonResponse("BrowserSessionResponse", "Invitation accepted"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/auth/recovery": {
        post: {
          operationId: "recoverBrowserSession",
          tags: ["identity"],
          requestBody: {
            required: true,
            content: {
              "application/json": { schema: { $ref: "#/components/schemas/RecoveryLoginRequest" } },
            },
          },
          responses: {
            "200": jsonResponse("BrowserSessionResponse", "Recovered browser session"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/auth/child-enrollments/redeem": {
        post: {
          operationId: "redeemChildEnrollment",
          tags: ["identity"],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/ChildEnrollmentRedeemRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("BrowserSessionResponse", "Enrolled child browser session"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/auth/child-session/renew": {
        post: {
          operationId: "renewChildSession",
          tags: ["identity"],
          security: [{ cookieAuth: [] }],
          description:
            "Renew only an active enrolled child device. After 24 hours, rotate to a new 30-day session; a predecessor may recover the identical active successor for ten minutes. Expired or revoked devices require guardian enrollment. The predecessor itself is the atomic idempotency scope; concurrent keys cannot create extra successors.",
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
          ],
          responses: {
            "200": jsonResponse("ChildSessionRenewResponse", "Renewed child device session"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/auth/session/rotate": {
        post: {
          operationId: "rotateBrowserSession",
          tags: ["identity"],
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          responses: {
            "200": jsonResponse("BrowserSessionResponse", "Rotated browser session"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/auth/logout": {
        post: {
          operationId: "logoutBrowserSession",
          tags: ["identity"],
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          responses: {
            "200": jsonResponse("SuccessResponse", "Current browser session revoked"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/me": {
        get: {
          operationId: "getMe",
          tags: ["identity"],
          security: [{ bearerAuth: [] }],
          parameters: [{ $ref: "#/components/parameters/WorkspaceIdHeader" }],
          responses: {
            "200": jsonResponse("MeResponse", "Authenticated actor context"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}": {
        get: {
          operationId: "getWorkspaceSettings",
          tags: ["family"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [{ $ref: "#/components/parameters/WorkspaceIdPath" }],
          responses: {
            "200": jsonResponse("WorkspaceSettingsResponse", "Workspace settings"),
            ...errorResponses,
          },
        },
        patch: {
          operationId: "updateWorkspaceSettings",
          tags: ["family"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [{ $ref: "#/components/parameters/WorkspaceIdPath" }],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/UpdateWorkspaceSettingsRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("WorkspaceSettingsResponse", "Workspace settings updated"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/children": {
        get: {
          operationId: "listChildren",
          tags: ["family"],
          security: [{ bearerAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { name: "cursor", in: "query", schema: { type: "string" } },
            {
              name: "limit",
              in: "query",
              schema: { type: "integer", minimum: 1, maximum: 100, default: 50 },
            },
          ],
          responses: {
            "200": jsonResponse("ChildProfilePage", "Workspace child profiles"),
            ...errorResponses,
          },
        },
        post: {
          operationId: "createChild",
          tags: ["family"],
          security: [{ bearerAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/CreateChildProfileRequest" },
              },
            },
          },
          responses: {
            "201": jsonResponse("CreateChildProfileResponse", "Child profile created"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/children/{childId}": {
        patch: {
          operationId: "updateChild",
          tags: ["family"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "childId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/UpdateChildProfileRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("ChildProfileResponse", "Child profile updated"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/children/{childId}/archive": {
        post: {
          operationId: "archiveChild",
          tags: ["family"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "childId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/ChildProfileVersionRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("ChildProfileResponse", "Child profile archived"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/children/{childId}/restore": {
        post: {
          operationId: "restoreChild",
          tags: ["family"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "childId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/ChildProfileVersionRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("ChildProfileResponse", "Child profile restored"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/inbox-items": {
        get: {
          operationId: "listInboxItems",
          tags: ["inbox"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "status",
              in: "query",
              required: false,
              schema: {
                type: "string",
                enum: ["untriaged", "planned", "routine_created", "cancelled"],
                default: "untriaged",
              },
            },
          ],
          responses: {
            "200": jsonResponse("InboxItemListResponse", "Inbox items"),
            ...errorResponses,
          },
        },
        post: {
          operationId: "createInboxItem",
          tags: ["inbox"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/CreateInboxItemRequest" },
              },
            },
          },
          responses: {
            "201": jsonResponse("CreateInboxItemResponse", "Inbox item captured"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/inbox-items/{inboxItemId}/commands/plan": {
        post: {
          operationId: "planInboxItem",
          tags: ["inbox"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "inboxItemId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/PlanInboxItemRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("PlanInboxItemResponse", "Inbox item planned as a task"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/inbox-items/{inboxItemId}/commands/cancel": {
        post: {
          operationId: "cancelInboxItem",
          tags: ["inbox"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "inboxItemId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/CancelInboxItemRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("CancelInboxItemResponse", "Inbox item cancelled"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/tasks/backlog": {
        get: {
          operationId: "listBacklogTasks",
          tags: ["planning"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "child_id",
              in: "query",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            { name: "cursor", in: "query", schema: { type: "string" } },
            {
              name: "limit",
              in: "query",
              schema: { type: "integer", minimum: 1, maximum: 100, default: 50 },
            },
          ],
          responses: {
            "200": jsonResponse("BacklogTaskListResponse", "Tasks without a planned date"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/tasks/carryovers": {
        get: {
          operationId: "listCarryoverTasks",
          tags: ["planning"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "child_id",
              in: "query",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "local_date",
              in: "query",
              required: true,
              schema: { type: "string", format: "date" },
            },
            { name: "cursor", in: "query", schema: { type: "string" } },
            {
              name: "limit",
              in: "query",
              schema: { type: "integer", minimum: 1, maximum: 100, default: 50 },
            },
          ],
          responses: {
            "200": jsonResponse(
              "CarryoverTaskListResponse",
              "Unfinished tasks planned before the selected local date",
            ),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/tasks": {
        get: {
          operationId: "listScheduledTasks",
          tags: ["planning"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "child_id",
              in: "query",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "date_from",
              in: "query",
              required: true,
              schema: { type: "string", format: "date" },
            },
            {
              name: "date_to",
              in: "query",
              required: true,
              schema: { type: "string", format: "date" },
            },
            { name: "cursor", in: "query", schema: { type: "string" } },
            {
              name: "limit",
              in: "query",
              schema: { type: "integer", minimum: 1, maximum: 100, default: 50 },
            },
          ],
          responses: {
            "200": jsonResponse("TaskListResponse", "Scheduled tasks in a bounded date range"),
            ...errorResponses,
          },
        },
        post: {
          operationId: "createAssignedTask",
          tags: ["planning"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/CreateAssignedTaskRequest" },
              },
            },
          },
          responses: {
            "201": jsonResponse("CreateAssignedTaskResponse", "Assigned task created"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/tasks/{taskId}/schedule": {
        patch: {
          operationId: "rescheduleTask",
          tags: ["planning"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "taskId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/RescheduleTaskRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("RescheduleTaskResponse", "Task schedule updated"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/tasks/{taskId}": {
        patch: {
          operationId: "updateTask",
          tags: ["planning"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "taskId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/UpdateTaskRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("UpdateTaskResponse", "Task content updated"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/tasks/{taskId}/structure": {
        get: {
          operationId: "getTaskStructure",
          tags: ["planning"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "taskId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "assignment_id",
              in: "query",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
          ],
          responses: {
            "200": jsonResponse("TaskStructureResponse", "Checklist and dependencies for a Task"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/tasks/{taskId}/checklist": {
        post: {
          operationId: "createTaskChecklistItem",
          tags: ["planning"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "taskId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/CreateTaskChecklistItemRequest" },
              },
            },
          },
          responses: {
            "201": jsonResponse("TaskChecklistItemMutationResponse", "Checklist item created"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/tasks/{taskId}/checklist/{itemId}": {
        patch: {
          operationId: "updateTaskChecklistItem",
          tags: ["planning"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "taskId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "itemId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/UpdateTaskChecklistItemRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("TaskChecklistItemMutationResponse", "Checklist item updated"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/tasks/{taskId}/checklist/{itemId}/commands/{command}": {
        post: {
          operationId: "runTaskChecklistItemCommand",
          tags: ["planning"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "taskId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "itemId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "command",
              in: "path",
              required: true,
              schema: { type: "string", enum: ["complete", "reopen", "remove"] },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/TaskChecklistItemCommandRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse(
              "TaskChecklistItemMutationResponse",
              "Checklist item command applied",
            ),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/tasks/{taskId}/dependencies": {
        post: {
          operationId: "createTaskDependency",
          tags: ["planning"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "taskId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/CreateTaskDependencyRequest" },
              },
            },
          },
          responses: {
            "201": jsonResponse("TaskDependencyMutationResponse", "Task dependency created"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/tasks/{taskId}/dependencies/{dependencyId}/commands/remove":
        {
          post: {
            operationId: "removeTaskDependency",
            tags: ["planning"],
            security: [{ bearerAuth: [] }, { cookieAuth: [] }],
            parameters: [
              { $ref: "#/components/parameters/WorkspaceIdPath" },
              {
                name: "taskId",
                in: "path",
                required: true,
                schema: { type: "string", format: "uuid" },
              },
              {
                name: "dependencyId",
                in: "path",
                required: true,
                schema: { type: "string", format: "uuid" },
              },
              { $ref: "#/components/parameters/IdempotencyKeyHeader" },
              { $ref: "#/components/parameters/CsrfHeader" },
            ],
            requestBody: {
              required: true,
              content: {
                "application/json": {
                  schema: { $ref: "#/components/schemas/RemoveTaskDependencyRequest" },
                },
              },
            },
            responses: {
              "200": jsonResponse("TaskDependencyMutationResponse", "Task dependency removed"),
              ...errorResponses,
            },
          },
        },
      "/api/v1/workspaces/{workspaceId}/tasks/{taskId}/dependencies/{dependencyId}/commands/override":
        {
          post: {
            operationId: "overrideTaskDependency",
            tags: ["planning"],
            description:
              "Overrides one unsatisfied dependency after recent interactive guardian authentication. OAuth MCP Bearer tokens must hand off to the parent web app.",
            security: [{ cookieAuth: [] }],
            parameters: [
              { $ref: "#/components/parameters/WorkspaceIdPath" },
              {
                name: "taskId",
                in: "path",
                required: true,
                schema: { type: "string", format: "uuid" },
              },
              {
                name: "dependencyId",
                in: "path",
                required: true,
                schema: { type: "string", format: "uuid" },
              },
              { $ref: "#/components/parameters/IdempotencyKeyHeader" },
              { $ref: "#/components/parameters/CsrfHeader" },
            ],
            requestBody: {
              required: true,
              content: {
                "application/json": {
                  schema: { $ref: "#/components/schemas/OverrideTaskDependencyRequest" },
                },
              },
            },
            responses: {
              "200": jsonResponse("TaskDependencyMutationResponse", "Task dependency overridden"),
              ...errorResponses,
            },
          },
        },
      "/api/v1/notifications/web-push/config": {
        get: {
          operationId: "getWebPushConfig",
          tags: ["notifications"],
          responses: {
            "200": jsonResponse("WebPushConfigResponse", "Public Web Push configuration"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/web-push-subscription": {
        get: {
          operationId: "getCurrentWebPushSubscription",
          tags: ["notifications"],
          security: [{ cookieAuth: [] }],
          parameters: [{ $ref: "#/components/parameters/WorkspaceIdPath" }],
          responses: {
            "200": jsonResponse(
              "WebPushSubscriptionResponse",
              "Current device Web Push subscription",
            ),
            ...errorResponses,
          },
        },
        put: {
          operationId: "upsertCurrentWebPushSubscription",
          tags: ["notifications"],
          description:
            "Registers the authenticated browser device subscription. OAuth MCP callers must hand off to the web app.",
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/WebPushSubscriptionInput" },
              },
            },
          },
          responses: {
            "200": jsonResponse(
              "WebPushSubscriptionResponse",
              "Current device Web Push subscription registered",
            ),
            ...errorResponses,
          },
        },
        delete: {
          operationId: "deleteCurrentWebPushSubscription",
          tags: ["notifications"],
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/WebPushSubscriptionDeleteRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse(
              "WebPushSubscriptionResponse",
              "Current device Web Push subscription revoked",
            ),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/tasks/{taskId}/evidence": {
        get: {
          operationId: "listTaskEvidence",
          tags: ["evidence"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "taskId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "assignment_id",
              in: "query",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
          ],
          responses: {
            "200": jsonResponse("EvidenceListResponse", "Authorized Task evidence metadata"),
            ...errorResponses,
          },
        },
        post: {
          operationId: "createTaskNoteEvidence",
          tags: ["evidence"],
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "taskId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/CreateNoteEvidenceRequest" },
              },
            },
          },
          responses: {
            "201": jsonResponse("EvidenceMutationResponse", "Note evidence created"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/tasks/{taskId}/evidence/uploads": {
        post: {
          operationId: "reservePhotoEvidenceUpload",
          tags: ["evidence"],
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "taskId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/CreateEvidenceUploadRequest" },
              },
            },
          },
          responses: {
            "201": jsonResponse(
              "EvidenceUploadReservationResponse",
              "Bounded private upload reservation",
            ),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/tasks/{taskId}/evidence/uploads/{uploadId}/{variant}": {
        put: {
          operationId: "putPhotoEvidenceObject",
          tags: ["evidence"],
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "taskId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "uploadId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "variant",
              in: "path",
              required: true,
              schema: { type: "string", enum: ["full", "thumbnail"] },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "image/jpeg": { schema: { type: "string", format: "binary" } },
              "image/png": { schema: { type: "string", format: "binary" } },
            },
          },
          responses: {
            "200": jsonResponse("EvidenceObjectUploadResponse", "Quarantined object stored"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/tasks/{taskId}/evidence/uploads/{uploadId}/finalize": {
        post: {
          operationId: "finalizePhotoEvidenceUpload",
          tags: ["evidence"],
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "taskId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "uploadId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/FinalizeEvidenceUploadRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("EvidenceMutationResponse", "Sanitized photo evidence ready"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/evidence/{evidenceId}/access": {
        post: {
          operationId: "createEvidenceAccessGrant",
          tags: ["evidence"],
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "evidenceId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/EvidenceAccessRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("EvidenceAccessResponse", "Short-lived private media access"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/evidence/{evidenceId}": {
        delete: {
          operationId: "deleteEvidence",
          tags: ["evidence"],
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "evidenceId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/DeleteEvidenceRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("EvidenceMutationResponse", "Evidence deleted"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/media/evidence/{grantId}": {
        get: {
          operationId: "readEvidenceMedia",
          tags: ["evidence"],
          security: [],
          parameters: [
            {
              name: "grantId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "Authorization",
              in: "header",
              required: true,
              schema: { type: "string", pattern: "^Evidence .+$" },
            },
          ],
          responses: {
            "200": {
              description: "Private sanitized evidence bytes",
              content: {
                "image/jpeg": { schema: { type: "string", format: "binary" } },
                "image/png": { schema: { type: "string", format: "binary" } },
              },
            },
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/notifications": {
        get: {
          operationId: "listNotifications",
          tags: ["notifications"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "unread_only",
              in: "query",
              required: false,
              schema: { type: "boolean", default: false },
            },
            {
              name: "limit",
              in: "query",
              required: false,
              schema: { type: "integer", minimum: 1, maximum: 100, default: 50 },
            },
            {
              name: "cursor",
              in: "query",
              required: false,
              schema: { type: "string", minLength: 1 },
            },
          ],
          responses: {
            "200": jsonResponse("NotificationListResponse", "Durable notifications"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/task-icons/resolve": {
        post: {
          operationId: "resolveTaskIcons",
          tags: ["tasks"],
          description:
            "Resolve shared decorative icons for authorized assignments. Content-addressed, idempotent materialization; an unchanged subject reuses its durable result indefinitely.",
          security: [{ cookieAuth: [] }, { bearerAuth: [] }],
          parameters: [{ $ref: "#/components/parameters/WorkspaceIdPath" }],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/TaskIconResolveRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("TaskIconResolveResponse", "Resolved icons or pending selections"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/daily-summary": {
        get: {
          operationId: "getDailySummary",
          tags: ["notifications"],
          security: [{ cookieAuth: [] }, { bearerAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "date",
              in: "query",
              required: false,
              schema: { type: "string", format: "date" },
            },
          ],
          responses: { "200": jsonResponse("DailySummaryResponse", "Success"), ...errorResponses },
        },
      },
      "/api/v1/workspaces/{workspaceId}/daily-summary/settings": {
        get: {
          operationId: "getDailySummarySettings",
          tags: ["notifications"],
          security: [{ cookieAuth: [] }, { bearerAuth: [] }],
          parameters: [{ $ref: "#/components/parameters/WorkspaceIdPath" }],
          responses: {
            "200": jsonResponse("DailySummarySettingsResponse", "Success"),
            ...errorResponses,
          },
        },
        post: {
          operationId: "updateDailySummarySettings",
          tags: ["notifications"],
          security: [{ cookieAuth: [] }, { bearerAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "Idempotency-Key",
              in: "header",
              required: true,
              schema: { type: "string", minLength: 16, maxLength: 200 },
            },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/DailySummarySettingsInput" },
              },
            },
          },
          responses: { "200": jsonResponse("SuccessResponse", "Success"), ...errorResponses },
        },
      },
      "/api/v1/workspaces/{workspaceId}/daily-summary/email/request": {
        post: {
          operationId: "requestDailySummaryEmail",
          tags: ["notifications"],
          security: [{ cookieAuth: [] }, { bearerAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "Idempotency-Key",
              in: "header",
              required: true,
              schema: { type: "string", minLength: 16, maxLength: 200 },
            },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/DailySummaryEmailRequest" },
              },
            },
          },
          responses: { "200": jsonResponse("SuccessResponse", "Success"), ...errorResponses },
        },
      },
      "/api/v1/workspaces/{workspaceId}/daily-summary/email/confirm": {
        post: {
          operationId: "confirmDailySummaryEmail",
          tags: ["notifications"],
          security: [{ cookieAuth: [] }, { bearerAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "Idempotency-Key",
              in: "header",
              required: true,
              schema: { type: "string", minLength: 16, maxLength: 200 },
            },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/DailySummaryEmailConfirm" },
              },
            },
          },
          responses: { "200": jsonResponse("SuccessResponse", "Success"), ...errorResponses },
        },
      },
      "/api/v1/workspaces/{workspaceId}/notification-preferences": {
        get: {
          operationId: "listNotificationPreferences",
          tags: ["notifications"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [{ $ref: "#/components/parameters/WorkspaceIdPath" }],
          responses: {
            "200": jsonResponse(
              "NotificationPreferenceListResponse",
              "Guardian notification preferences",
            ),
            ...errorResponses,
          },
        },
        put: {
          operationId: "upsertNotificationPreference",
          tags: ["notifications"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/NotificationPreferenceInput" },
              },
            },
          },
          responses: {
            "200": jsonResponse(
              "NotificationPreferenceMutationResponse",
              "Notification preference saved",
            ),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/notifications/{notificationId}/commands/{command}": {
        post: {
          operationId: "commandNotification",
          tags: ["notifications"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "notificationId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "command",
              in: "path",
              required: true,
              schema: { type: "string", enum: ["read", "unread", "snooze"] },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: {
                  oneOf: [
                    { $ref: "#/components/schemas/NotificationReadCommandRequest" },
                    { $ref: "#/components/schemas/NotificationSnoozeCommandRequest" },
                  ],
                },
              },
            },
          },
          responses: {
            "200": jsonResponse("NotificationCommandResponse", "Notification state updated"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/routine-templates": {
        get: {
          operationId: "listRoutineTemplates",
          tags: ["routines"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "include_archived",
              in: "query",
              required: false,
              schema: { type: "boolean", default: false },
            },
          ],
          responses: {
            "200": jsonResponse("RoutineTemplateListResponse", "Workspace Routine templates"),
            ...errorResponses,
          },
        },
        post: {
          operationId: "createRoutineTemplate",
          tags: ["routines"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/CreateRoutineTemplateRequest" },
              },
            },
          },
          responses: {
            "201": jsonResponse("RoutineTemplateMutationResponse", "Routine template created"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/routine-templates/{templateId}": {
        patch: {
          operationId: "updateRoutineTemplate",
          tags: ["routines"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "templateId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/UpdateRoutineTemplateRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("RoutineTemplateMutationResponse", "Routine template updated"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/routine-templates/{templateId}/commands/{command}": {
        post: {
          operationId: "commandRoutineTemplateArchive",
          tags: ["routines"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "templateId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "command",
              in: "path",
              required: true,
              schema: { type: "string", enum: ["archive", "restore"] },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/RoutineTemplateArchiveCommandRequest",
                },
              },
            },
          },
          responses: {
            "200": jsonResponse(
              "RoutineTemplateArchiveCommandResponse",
              "Routine template archive state updated",
            ),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/routines": {
        get: {
          operationId: "listRoutines",
          tags: ["routines"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "child_id",
              in: "query",
              required: false,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "include_archived",
              in: "query",
              required: false,
              schema: { type: "boolean", default: false },
            },
          ],
          responses: {
            "200": jsonResponse("RoutineListResponse", "Workspace Routines"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/routines/reconciliations": {
        get: {
          operationId: "listRoutineReconciliations",
          tags: ["routines"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [{ $ref: "#/components/parameters/WorkspaceIdPath" }],
          responses: {
            "200": jsonResponse(
              "RoutineReconciliationListResponse",
              "Recent Routine reconciliation runs",
            ),
            ...errorResponses,
          },
        },
        post: {
          operationId: "reconcileRoutines",
          tags: ["routines"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/RoutineReconciliationRequest" },
              },
            },
          },
          responses: {
            "202": jsonResponse("RoutineReconciliationResponse", "Routine reconciliation queued"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/routines/{routineId}/versions": {
        get: {
          operationId: "listRoutineVersions",
          tags: ["routines"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "routineId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "limit",
              in: "query",
              required: false,
              schema: { type: "integer", minimum: 1, maximum: 50, default: 20 },
            },
            {
              name: "cursor",
              in: "query",
              required: false,
              schema: { type: "string" },
            },
          ],
          responses: {
            "200": jsonResponse("RoutineVersionHistoryResponse", "Immutable Routine versions"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/routines/{routineId}/versions/compare": {
        get: {
          operationId: "compareRoutineVersions",
          tags: ["routines"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "routineId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "from_version",
              in: "query",
              required: true,
              schema: { type: "integer", minimum: 1 },
            },
            {
              name: "to_version",
              in: "query",
              required: true,
              schema: { type: "integer", minimum: 1 },
            },
          ],
          responses: {
            "200": jsonResponse(
              "RoutineVersionComparisonResponse",
              "Compared immutable Routine versions",
            ),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/routines/{routineId}/previews": {
        post: {
          operationId: "previewRoutineUpdate",
          tags: ["routines"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "routineId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/RoutineUpdatePreviewRequest" },
              },
            },
          },
          responses: {
            "201": jsonResponse("RoutineUpdatePreviewResponse", "Routine update preview created"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/routines/{routineId}/apply": {
        post: {
          operationId: "applyRoutineUpdate",
          tags: ["routines"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "routineId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/RoutineUpdateApplyRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("RoutineUpdateApplyResponse", "Routine update applied"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/routines/{routineId}/commands/{command}": {
        post: {
          operationId: "commandRoutineStatus",
          tags: ["routines"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "routineId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "command",
              in: "path",
              required: true,
              schema: { type: "string", enum: ["pause", "resume"] },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/RoutineStatusCommandRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("RoutineStatusCommandResponse", "Routine status updated"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/routines/previews": {
        post: {
          operationId: "previewRoutineCreate",
          tags: ["routines"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/RoutineCreatePreviewRequest" },
              },
            },
          },
          responses: {
            "201": jsonResponse(
              "RoutineCreatePreviewResponse",
              "Routine creation preview persisted",
            ),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/routines/apply": {
        post: {
          operationId: "applyRoutineCreate",
          tags: ["routines"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/RoutineCreateApplyRequest" },
              },
            },
          },
          responses: {
            "201": jsonResponse("RoutineCreateApplyResponse", "Routine and Tasks created"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/areas": {
        get: {
          operationId: "listAreas",
          tags: ["planning"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "include_archived",
              in: "query",
              schema: { type: "boolean", default: false },
            },
          ],
          responses: { "200": jsonResponse("AreaListResponse", "Areas listed"), ...errorResponses },
        },
        post: {
          operationId: "createArea",
          tags: ["planning"],
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": { schema: { $ref: "#/components/schemas/CreateAreaRequest" } },
            },
          },
          responses: {
            "201": jsonResponse("AreaMutationResponse", "Area created"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/areas/reorder": {
        post: {
          operationId: "reorderAreas",
          tags: ["planning"],
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": { schema: { $ref: "#/components/schemas/AreaReorderRequest" } },
            },
          },
          responses: {
            "200": jsonResponse("AreaReorderResponse", "Areas reordered"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/areas/{areaId}": {
        patch: {
          operationId: "updateArea",
          tags: ["planning"],
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "areaId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": { schema: { $ref: "#/components/schemas/UpdateAreaRequest" } },
            },
          },
          responses: {
            "200": jsonResponse("AreaMutationResponse", "Area updated"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/areas/{areaId}/commands/{command}": {
        post: {
          operationId: "commandAreaArchive",
          tags: ["planning"],
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "areaId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "command",
              in: "path",
              required: true,
              schema: { type: "string", enum: ["archive", "restore"] },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/AreaArchiveCommandRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("AreaArchiveCommandResponse", "Area archive state changed"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/terms": {
        get: {
          operationId: "listTerms",
          tags: ["planning"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { name: "include_archived", in: "query", schema: { type: "boolean", default: false } },
          ],
          responses: { "200": jsonResponse("TermListResponse", "Terms listed"), ...errorResponses },
        },
        post: {
          operationId: "createTerm",
          tags: ["planning"],
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": { schema: { $ref: "#/components/schemas/CreateTermRequest" } },
            },
          },
          responses: {
            "201": jsonResponse("TermMutationResponse", "Term created"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/terms/{termId}": {
        patch: {
          operationId: "updateTerm",
          tags: ["planning"],
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "termId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": { schema: { $ref: "#/components/schemas/UpdateTermRequest" } },
            },
          },
          responses: {
            "200": jsonResponse("TermMutationResponse", "Term updated"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/terms/{termId}/commands/{command}": {
        post: {
          operationId: "commandTermArchive",
          tags: ["planning"],
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "termId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "command",
              in: "path",
              required: true,
              schema: { type: "string", enum: ["archive", "restore"] },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/TermArchiveCommandRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("TermArchiveCommandResponse", "Term archive state changed"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/calendars": {
        get: {
          operationId: "listWorkspaceCalendars",
          tags: ["planning"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { name: "include_archived", in: "query", schema: { type: "boolean", default: false } },
          ],
          responses: {
            "200": jsonResponse("WorkspaceCalendarListResponse", "Workspace calendars listed"),
            ...errorResponses,
          },
        },
        post: {
          operationId: "createWorkspaceCalendar",
          tags: ["planning"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/CreateWorkspaceCalendarRequest" },
              },
            },
          },
          responses: {
            "201": jsonResponse("WorkspaceCalendarMutationResponse", "Workspace calendar created"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/calendars/{calendarId}": {
        patch: {
          operationId: "updateWorkspaceCalendar",
          tags: ["planning"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "calendarId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/UpdateWorkspaceCalendarRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("WorkspaceCalendarMutationResponse", "Workspace calendar updated"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/calendars/{calendarId}/commands/{command}": {
        post: {
          operationId: "commandWorkspaceCalendarArchive",
          tags: ["planning"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "calendarId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "command",
              in: "path",
              required: true,
              schema: { type: "string", enum: ["archive", "restore"] },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/WorkspaceCalendarArchiveCommandRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse(
              "WorkspaceCalendarArchiveCommandResponse",
              "Workspace calendar archive state changed",
            ),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/cycles": {
        get: {
          operationId: "listFamilyCycles",
          tags: ["reviews"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { name: "include_closed", in: "query", schema: { type: "boolean", default: false } },
          ],
          responses: {
            "200": jsonResponse("FamilyCycleListResponse", "Family Cycles listed"),
            ...errorResponses,
          },
        },
        post: {
          operationId: "createFamilyCycle",
          tags: ["reviews"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/CreateFamilyCycleRequest" },
              },
            },
          },
          responses: {
            "201": jsonResponse("FamilyCycleMutationResponse", "Family Cycle created"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/cycles/current": {
        get: {
          operationId: "getChildCurrentFamilyCycle",
          tags: ["reviews"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "child_id",
              in: "query",
              required: false,
              schema: { type: "string", format: "uuid" },
              description: "Required for adult callers; child sessions use their bound child.",
            },
            {
              name: "local_date",
              in: "query",
              required: true,
              schema: { type: "string", format: "date" },
            },
          ],
          responses: {
            "200": jsonResponse(
              "ChildCurrentFamilyCycleResponse",
              "Child-safe current Family Cycle read",
            ),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/cycles/{cycleId}": {
        get: {
          operationId: "getFamilyCycle",
          tags: ["reviews"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "cycleId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
          ],
          responses: {
            "200": jsonResponse("FamilyCycleResponse", "Family Cycle read"),
            ...errorResponses,
          },
        },
        patch: {
          operationId: "updateFamilyCyclePlan",
          tags: ["reviews"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "cycleId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/UpdateFamilyCyclePlanRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("FamilyCycleMutationResponse", "Family Cycle plan updated"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/cycles/{cycleId}/review": {
        patch: {
          operationId: "updateFamilyCycleReview",
          tags: ["reviews"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "cycleId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/UpdateFamilyCycleReviewRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("FamilyCycleMutationResponse", "Family Cycle review updated"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/cycles/{cycleId}/commands/{command}": {
        post: {
          operationId: "commandFamilyCycle",
          tags: ["reviews"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "cycleId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "command",
              in: "path",
              required: true,
              schema: {
                type: "string",
                enum: [
                  "plan",
                  "return_to_draft",
                  "activate",
                  "start_review",
                  "return_to_active",
                  "close",
                  "reopen_review",
                ],
              },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/FamilyCycleCommandRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("FamilyCycleCommandResponse", "Family Cycle state changed"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/cycles/{cycleId}/actions/{actionId}/commands/{command}": {
        post: {
          operationId: "commandFamilyCycleReviewAction",
          tags: ["reviews"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "cycleId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "actionId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "command",
              in: "path",
              required: true,
              schema: { type: "string", enum: ["apply", "dismiss"] },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: {
                  oneOf: [
                    { $ref: "#/components/schemas/ApplyReviewActionRequest" },
                    { $ref: "#/components/schemas/DismissReviewActionRequest" },
                  ],
                },
              },
            },
          },
          responses: {
            "200": jsonResponse(
              "ReviewActionCommandResponse",
              "Review action applied or dismissed",
            ),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/projects": {
        get: {
          operationId: "listProjects",
          tags: ["planning"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "include_archived",
              in: "query",
              required: false,
              schema: { type: "boolean", default: false },
            },
          ],
          responses: {
            "200": jsonResponse("ProjectListResponse", "Workspace projects"),
            ...errorResponses,
          },
        },
        post: {
          operationId: "createProject",
          tags: ["planning"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": { schema: { $ref: "#/components/schemas/CreateProjectRequest" } },
            },
          },
          responses: {
            "201": jsonResponse("CreateProjectResponse", "Project created"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/projects/{projectId}": {
        patch: {
          operationId: "updateProject",
          tags: ["planning"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "projectId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": { schema: { $ref: "#/components/schemas/UpdateProjectRequest" } },
            },
          },
          responses: {
            "200": jsonResponse("UpdateProjectResponse", "Project updated"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/projects/{projectId}/commands/{command}": {
        post: {
          operationId: "commandProjectArchiveState",
          tags: ["planning"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "projectId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "command",
              in: "path",
              required: true,
              schema: { type: "string", enum: ["archive", "restore"] },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/ProjectArchiveCommandRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("ProjectArchiveCommandResponse", "Project archive state changed"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/projects/{projectId}/milestones": {
        post: {
          operationId: "createMilestone",
          tags: ["planning"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "projectId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/CreateMilestoneRequest" },
              },
            },
          },
          responses: {
            "201": jsonResponse("CreateMilestoneResponse", "Milestone created"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/projects/{projectId}/milestones/{milestoneId}/commands/{command}":
        {
          post: {
            operationId: "runMilestoneCommand",
            tags: ["planning"],
            security: [{ bearerAuth: [] }, { cookieAuth: [] }],
            parameters: [
              { $ref: "#/components/parameters/WorkspaceIdPath" },
              {
                name: "projectId",
                in: "path",
                required: true,
                schema: { type: "string", format: "uuid" },
              },
              {
                name: "milestoneId",
                in: "path",
                required: true,
                schema: { type: "string", format: "uuid" },
              },
              {
                name: "command",
                in: "path",
                required: true,
                schema: { type: "string", enum: ["start", "complete"] },
              },
              { $ref: "#/components/parameters/IdempotencyKeyHeader" },
              { $ref: "#/components/parameters/CsrfHeader" },
            ],
            requestBody: {
              required: true,
              content: {
                "application/json": {
                  schema: { $ref: "#/components/schemas/MilestoneCommandRequest" },
                },
              },
            },
            responses: {
              "200": jsonResponse("MilestoneCommandResponse", "Milestone updated"),
              ...errorResponses,
            },
          },
        },
      "/api/v1/workspaces/{workspaceId}/dashboard": {
        get: {
          operationId: "getDashboard",
          tags: ["insights"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "from",
              in: "query",
              required: true,
              schema: { type: "string", format: "date" },
            },
            {
              name: "to",
              in: "query",
              required: true,
              schema: { type: "string", format: "date" },
            },
            {
              name: "child_id",
              in: "query",
              required: false,
              schema: { type: "string", format: "uuid" },
            },
          ],
          responses: {
            "200": jsonResponse("DashboardResponse", "Reconciled family activity dashboard"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/search": {
        get: {
          operationId: "searchWorkspaceContent",
          tags: ["search-history"],
          description:
            "Search Task, Routine, Project, evidence-note, and review-note content visible to an owner or guardian.",
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "query",
              in: "query",
              required: false,
              schema: { type: "string", minLength: 1, maxLength: 200 },
            },
            {
              name: "document_types",
              in: "query",
              required: false,
              style: "form",
              explode: true,
              schema: {
                type: "array",
                minItems: 1,
                maxItems: 4,
                uniqueItems: true,
                items: { type: "string", enum: ["task", "routine", "project", "note"] },
              },
            },
            {
              name: "child_id",
              in: "query",
              required: false,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "statuses",
              in: "query",
              required: false,
              style: "form",
              explode: true,
              schema: {
                type: "array",
                maxItems: 30,
                uniqueItems: true,
                items: { type: "string", minLength: 1, maxLength: 120 },
              },
            },
            {
              name: "area_id",
              in: "query",
              required: false,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "project_id",
              in: "query",
              required: false,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "routine_id",
              in: "query",
              required: false,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "has_evidence",
              in: "query",
              required: false,
              schema: { type: "boolean" },
            },
            {
              name: "local_date_from",
              in: "query",
              required: false,
              schema: { type: "string", format: "date" },
            },
            {
              name: "local_date_to",
              in: "query",
              required: false,
              schema: { type: "string", format: "date" },
            },
            {
              name: "limit",
              in: "query",
              required: false,
              schema: { type: "integer", minimum: 1, maximum: 50, default: 50 },
            },
            {
              name: "cursor",
              in: "query",
              required: false,
              description: "Opaque signed cursor from the preceding page.",
              schema: { type: "string", minLength: 16, maxLength: 4096 },
            },
          ],
          responses: {
            "200": jsonResponse("SearchContentPageResponse", "Filtered Workspace search page"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/export": {
        post: {
          operationId: "createWorkspaceExport",
          tags: ["data-administration"],
          description:
            "Queue a recent-auth browser-only Workspace or child portable ZIP export. Remote MCP must hand off to the parent app.",
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/CreateWorkspaceExportRequest" },
              },
            },
          },
          responses: {
            "202": jsonResponse("WorkspaceExportResponse", "Portable export queued"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/exports": {
        get: {
          operationId: "listWorkspaceExports",
          tags: ["data-administration"],
          security: [{ cookieAuth: [] }],
          parameters: [{ $ref: "#/components/parameters/WorkspaceIdPath" }],
          responses: {
            "200": jsonResponse("WorkspaceExportListResponse", "Current guardian exports"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/exports/{exportId}": {
        get: {
          operationId: "getWorkspaceExport",
          tags: ["data-administration"],
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "exportId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
          ],
          responses: {
            "200": jsonResponse("WorkspaceExportResponse", "Portable export status"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/exports/{exportId}/download": {
        get: {
          operationId: "downloadWorkspaceExport",
          tags: ["data-administration"],
          description:
            "Download a completed, unexpired private ZIP after recent parent authentication.",
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "exportId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
          ],
          responses: {
            "200": {
              description: "Portable ZIP archive",
              content: { "application/zip": { schema: { type: "string", format: "binary" } } },
            },
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/exports/{exportId}/commands/delete": {
        post: {
          operationId: "deleteWorkspaceExport",
          tags: ["data-administration"],
          description:
            "Delete one private export artifact early after recent parent authentication.",
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "exportId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/DeleteWorkspaceExportRequest" },
              },
            },
          },
          responses: {
            "202": jsonResponse("WorkspaceExportResponse", "Export artifact deletion queued"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/history": {
        get: {
          operationId: "listWorkspaceProductHistory",
          tags: ["search-history"],
          description:
            "List ordinary product activity separately from the security audit stream for an owner or guardian.",
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "resource_types",
              in: "query",
              required: false,
              style: "form",
              explode: true,
              schema: {
                type: "array",
                maxItems: 4,
                uniqueItems: true,
                items: { type: "string", enum: ["task", "routine", "project", "note"] },
              },
            },
            {
              name: "event_types",
              in: "query",
              required: false,
              style: "form",
              explode: true,
              schema: {
                type: "array",
                maxItems: 30,
                uniqueItems: true,
                items: { type: "string", minLength: 1, maxLength: 120 },
              },
            },
            {
              name: "actor_id",
              in: "query",
              required: false,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "created_from",
              in: "query",
              required: false,
              schema: { type: "string", format: "date-time" },
            },
            {
              name: "created_to",
              in: "query",
              required: false,
              schema: { type: "string", format: "date-time" },
            },
            {
              name: "limit",
              in: "query",
              required: false,
              schema: { type: "integer", minimum: 1, maximum: 50, default: 50 },
            },
            {
              name: "cursor",
              in: "query",
              required: false,
              description: "Opaque signed cursor from the preceding page.",
              schema: { type: "string", minLength: 16, maxLength: 4096 },
            },
          ],
          responses: {
            "200": jsonResponse(
              "ProductHistoryPageResponse",
              "Filtered ordinary product-history page",
            ),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/security-audit": {
        get: {
          operationId: "listWorkspaceSecurityAudit",
          tags: ["search-history"],
          description:
            "Owner/guardian-only, secret-free security audit viewer. Audit summary and details payloads are never returned.",
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "event_types",
              in: "query",
              required: false,
              style: "form",
              explode: true,
              schema: {
                type: "array",
                maxItems: 30,
                uniqueItems: true,
                items: { type: "string", minLength: 1, maxLength: 120 },
              },
            },
            {
              name: "actor_id",
              in: "query",
              required: false,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "actor_types",
              in: "query",
              required: false,
              style: "form",
              explode: true,
              schema: {
                type: "array",
                maxItems: 3,
                uniqueItems: true,
                items: { type: "string", enum: ["adult", "child", "system"] },
              },
            },
            {
              name: "target_type",
              in: "query",
              required: false,
              schema: { type: "string", minLength: 1, maxLength: 120 },
            },
            {
              name: "target_id",
              in: "query",
              required: false,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "outcomes",
              in: "query",
              required: false,
              style: "form",
              explode: true,
              schema: {
                type: "array",
                maxItems: 3,
                uniqueItems: true,
                items: { type: "string", enum: ["success", "failure", "denied"] },
              },
            },
            {
              name: "created_from",
              in: "query",
              required: false,
              schema: { type: "string", format: "date-time" },
            },
            {
              name: "created_to",
              in: "query",
              required: false,
              schema: { type: "string", format: "date-time" },
            },
            {
              name: "limit",
              in: "query",
              required: false,
              schema: { type: "integer", minimum: 1, maximum: 50, default: 50 },
            },
            {
              name: "cursor",
              in: "query",
              required: false,
              description: "Opaque signed cursor from the preceding page.",
              schema: { type: "string", minLength: 16, maxLength: 4096 },
            },
          ],
          responses: {
            "200": jsonResponse(
              "SecurityAuditPageResponse",
              "Filtered secret-free security-audit page",
            ),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/today": {
        get: {
          operationId: "getToday",
          tags: ["planning"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "child_id",
              in: "query",
              required: false,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "date",
              in: "query",
              required: false,
              schema: { type: "string", format: "date" },
            },
          ],
          responses: {
            "200": jsonResponse("TodayTaskListResponse", "Workspace-timezone Today tasks"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/today/reorder": {
        post: {
          operationId: "reorderTodayTasks",
          tags: ["planning"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/TodayTaskReorderRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("TodayTaskReorderResponse", "Today tasks reordered"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/tasks/{taskId}/commands/{command}": {
        post: {
          operationId: "runTaskCommand",
          tags: ["planning"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "taskId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            {
              name: "command",
              in: "path",
              required: true,
              schema: {
                type: "string",
                enum: [
                  "start",
                  "complete",
                  "reopen",
                  "request-help",
                  "clear-help",
                  "verify",
                  "return",
                  "defer",
                  "skip",
                  "cancel",
                  "restore",
                ],
              },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": { schema: { $ref: "#/components/schemas/TaskCommandRequest" } },
            },
          },
          responses: {
            "200": jsonResponse("TaskCommandResponse", "Task command applied"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/realtime": {
        get: {
          operationId: "connectWorkspaceRealtime",
          tags: ["realtime"],
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "cursor",
              in: "query",
              required: false,
              schema: { type: "integer", minimum: 0 },
            },
          ],
          responses: {
            "101": { description: "WebSocket connection established" },
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/operations/runtime-proof": {
        post: {
          operationId: "startStagingRuntimeProof",
          tags: ["staging-operations"],
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/StagingRuntimeProofRequest" },
              },
            },
          },
          responses: {
            "202": jsonResponse("StagingRuntimeProofResponse", "Real binding proof started"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/operations/jobs/{jobId}": {
        get: {
          operationId: "getStagingRuntimeProofJob",
          tags: ["staging-operations"],
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "jobId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
          ],
          responses: {
            "200": jsonResponse("BackgroundJobResponse", "Persisted async job result"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/child-enrollments": {
        post: {
          operationId: "createChildEnrollment",
          tags: ["family"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [{ $ref: "#/components/parameters/WorkspaceIdPath" }],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/ChildEnrollmentCreateRequest" },
              },
            },
          },
          responses: {
            "201": jsonResponse("ChildEnrollmentCreateResponse", "One-time enrollment issued"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/devices": {
        get: {
          operationId: "listDevices",
          tags: ["family"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [{ $ref: "#/components/parameters/WorkspaceIdPath" }],
          responses: {
            "200": jsonResponse("DeviceListResponse", "Workspace devices"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/devices/{deviceId}": {
        patch: {
          operationId: "updateDeviceLabel",
          tags: ["family"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "deviceId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/UpdateDeviceLabelRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("SuccessResponse", "Device label updated"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/devices/{deviceId}/revoke": {
        post: {
          operationId: "revokeDevice",
          tags: ["family"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "deviceId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": { schema: { $ref: "#/components/schemas/DeviceRevokeRequest" } },
            },
          },
          responses: {
            "200": jsonResponse("SuccessResponse", "Device revoked"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/passkeys": {
        get: {
          operationId: "listPasskeys",
          tags: ["identity"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [{ $ref: "#/components/parameters/WorkspaceIdPath" }],
          responses: {
            "200": jsonResponse("PasskeyCredentialListResponse", "Current account passkeys"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/passkeys/{credentialId}": {
        patch: {
          operationId: "updatePasskeyLabel",
          tags: ["identity"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "credentialId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/UpdatePasskeyCredentialRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("SuccessResponse", "Passkey label updated"),
            ...errorResponses,
          },
        },
        delete: {
          operationId: "revokePasskey",
          tags: ["identity"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "credentialId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
          ],
          responses: {
            "200": jsonResponse("SuccessResponse", "Passkey revoked"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/mcp/oauth/register": {
        post: {
          operationId: "registerMcpOAuthClient",
          tags: ["mcp"],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/OAuthClientRegistrationRequest" },
              },
            },
          },
          responses: {
            "201": jsonResponse("OAuthClientRegistrationResponse", "OAuth client registered"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/mcp/oauth/authorization-requests": {
        post: {
          operationId: "createMcpAuthorizationRequest",
          tags: ["mcp"],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/OAuthAuthorizationRequestCreate" },
              },
            },
          },
          responses: {
            "201": jsonResponse(
              "OAuthAuthorizationRequestCreateResponse",
              "OAuth authorization request created",
            ),
            ...errorResponses,
          },
        },
      },
      "/api/v1/mcp/oauth/token": {
        post: {
          operationId: "exchangeMcpOAuthToken",
          tags: ["mcp"],
          requestBody: {
            required: true,
            content: {
              "application/x-www-form-urlencoded": {
                schema: {
                  type: "object",
                  properties: {
                    grant_type: { type: "string", enum: ["authorization_code", "refresh_token"] },
                    client_id: { type: "string", format: "uuid" },
                    code: { type: "string" },
                    code_verifier: { type: "string" },
                    redirect_uri: { type: "string", format: "uri" },
                    refresh_token: { type: "string" },
                  },
                  required: ["grant_type", "client_id"],
                },
              },
            },
          },
          responses: {
            "200": jsonResponse("OAuthTokenResponse", "OAuth token issued"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/mcp/oauth/revoke": {
        post: {
          operationId: "revokeMcpOAuthToken",
          tags: ["mcp"],
          requestBody: {
            required: true,
            content: {
              "application/x-www-form-urlencoded": {
                schema: {
                  type: "object",
                  properties: { token: { type: "string" } },
                  required: ["token"],
                },
              },
            },
          },
          responses: { "200": { description: "OAuth grant revoked" }, ...errorResponses },
        },
      },
      "/api/v1/mcp/me": {
        get: {
          operationId: "getMcpActor",
          tags: ["mcp"],
          security: [{ bearerAuth: [] }],
          responses: {
            "200": jsonResponse("McpActorResponse", "Authenticated MCP actor and grant"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/mcp/audit": {
        post: {
          operationId: "auditMcpToolCall",
          tags: ["mcp"],
          security: [{ bearerAuth: [] }],
          requestBody: {
            required: true,
            content: {
              "application/json": { schema: { $ref: "#/components/schemas/McpToolAuditRequest" } },
            },
          },
          responses: {
            "200": jsonResponse("SuccessResponse", "MCP call audited"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/mcp/resource-audit": {
        post: {
          operationId: "recordMcpResourceAudit",
          tags: ["mcp"],
          security: [{ bearerAuth: [] }],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/McpResourceAuditRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("SuccessResponse", "MCP resource read audit recorded"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/tasks/reschedule-previews": {
        post: {
          operationId: "createTaskBulkReschedulePreview",
          tags: ["planning"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/McpBulkReschedulePreviewRequest" },
              },
            },
          },
          responses: {
            "201": jsonResponse(
              "McpBulkReschedulePreviewResponse",
              "Bound, expiring bulk-reschedule preview",
            ),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/tasks/reschedule-previews/{previewId}/apply": {
        post: {
          operationId: "applyTaskBulkReschedulePreview",
          tags: ["planning"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "previewId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
            { $ref: "#/components/parameters/IdempotencyKeyHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/McpBulkRescheduleApplyRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse(
              "McpBulkRescheduleApplyResponse",
              "Confirmed preview applied atomically",
            ),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/mcp/authorization-requests/{authorizationRequestId}": {
        get: {
          operationId: "getMcpConsentRequest",
          tags: ["mcp"],
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            {
              name: "authorizationRequestId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
          ],
          responses: {
            "200": jsonResponse("OAuthConsentResponse", "OAuth consent details"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/mcp/authorization-requests/{authorizationRequestId}/approve":
        {
          post: {
            operationId: "approveMcpConsentRequest",
            tags: ["mcp"],
            security: [{ cookieAuth: [] }],
            parameters: [
              { $ref: "#/components/parameters/WorkspaceIdPath" },
              { $ref: "#/components/parameters/CsrfHeader" },
              {
                name: "authorizationRequestId",
                in: "path",
                required: true,
                schema: { type: "string", format: "uuid" },
              },
            ],
            requestBody: {
              required: true,
              content: {
                "application/json": {
                  schema: { $ref: "#/components/schemas/OAuthConsentApproveRequest" },
                },
              },
            },
            responses: {
              "200": jsonResponse("OAuthConsentApproveResponse", "OAuth consent approved"),
              ...errorResponses,
            },
          },
        },
      "/api/v1/workspaces/{workspaceId}/mcp/authorization-requests/{authorizationRequestId}/deny": {
        post: {
          operationId: "denyMcpConsentRequest",
          tags: ["mcp"],
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { $ref: "#/components/parameters/CsrfHeader" },
            {
              name: "authorizationRequestId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
          ],
          responses: {
            "200": jsonResponse("OAuthConsentApproveResponse", "OAuth consent denied"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/mcp/grants": {
        get: {
          operationId: "listMcpGrants",
          tags: ["mcp"],
          security: [{ cookieAuth: [] }],
          parameters: [{ $ref: "#/components/parameters/WorkspaceIdPath" }],
          responses: {
            "200": jsonResponse("AgentGrantListResponse", "Current account MCP grants"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/mcp/grants/{grantId}/revoke": {
        post: {
          operationId: "revokeMcpGrant",
          tags: ["mcp"],
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { $ref: "#/components/parameters/CsrfHeader" },
            {
              name: "grantId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/AgentGrantRevokeRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("SuccessResponse", "MCP grant revoked"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/memberships": {
        get: {
          operationId: "listMemberships",
          tags: ["family"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [{ $ref: "#/components/parameters/WorkspaceIdPath" }],
          responses: {
            "200": jsonResponse("WorkspaceMembershipListResponse", "Workspace memberships"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/memberships/{membershipId}": {
        patch: {
          operationId: "updateWorkspaceMembership",
          tags: ["family"],
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { $ref: "#/components/parameters/CsrfHeader" },
            {
              name: "membershipId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/UpdateWorkspaceMembershipRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("WorkspaceMembershipResponse", "Membership updated"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/ownership-transfer": {
        post: {
          operationId: "transferWorkspaceOwnership",
          tags: ["family"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/TransferWorkspaceOwnershipRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("WorkspaceMembershipResponse", "Ownership transferred"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/memberships/leave": {
        post: {
          operationId: "leaveWorkspace",
          tags: ["family"],
          security: [{ bearerAuth: [] }, { cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/LeaveWorkspaceRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("SuccessResponse", "Workspace left"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/membership-invitations": {
        get: {
          operationId: "listMembershipInvitations",
          tags: ["family"],
          security: [{ cookieAuth: [] }],
          parameters: [{ $ref: "#/components/parameters/WorkspaceIdPath" }],
          responses: {
            "200": jsonResponse("MembershipInvitationListResponse", "Membership invitations"),
            ...errorResponses,
          },
        },
        post: {
          operationId: "createMembershipInvitation",
          tags: ["family"],
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { $ref: "#/components/parameters/CsrfHeader" },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/CreateMembershipInvitationRequest" },
              },
            },
          },
          responses: {
            "201": jsonResponse("CreateMembershipInvitationResponse", "Invitation created"),
            ...errorResponses,
          },
        },
      },
      "/api/v1/workspaces/{workspaceId}/membership-invitations/{invitationId}/revoke": {
        post: {
          operationId: "revokeMembershipInvitation",
          tags: ["family"],
          security: [{ cookieAuth: [] }],
          parameters: [
            { $ref: "#/components/parameters/WorkspaceIdPath" },
            { $ref: "#/components/parameters/CsrfHeader" },
            {
              name: "invitationId",
              in: "path",
              required: true,
              schema: { type: "string", format: "uuid" },
            },
          ],
          requestBody: {
            required: true,
            content: {
              "application/json": {
                schema: { $ref: "#/components/schemas/RevokeMembershipInvitationRequest" },
              },
            },
          },
          responses: {
            "200": jsonResponse("SuccessResponse", "Invitation revoked"),
            ...errorResponses,
          },
        },
      },
    },
    components: {
      securitySchemes: {
        bearerAuth: { type: "http", scheme: "bearer", bearerFormat: "opaque-session" },
        cookieAuth: { type: "apiKey", in: "cookie", name: "oyako_session" },
      },
      parameters: {
        WorkspaceIdHeader: {
          name: "X-Workspace-Id",
          in: "header",
          required: true,
          schema: { type: "string", format: "uuid" },
        },
        WorkspaceIdPath: {
          name: "workspaceId",
          in: "path",
          required: true,
          schema: { type: "string", format: "uuid" },
        },
        IdempotencyKeyHeader: {
          name: "Idempotency-Key",
          in: "header",
          required: true,
          schema: { type: "string", minLength: 16, maxLength: 200 },
        },
        CsrfHeader: {
          name: "X-CSRF-Token",
          in: "header",
          required: false,
          description: "Required for cookie-authenticated mutations; bearer clients omit it.",
          schema: { type: "string", minLength: 24, maxLength: 256 },
        },
      },
      schemas: {
        ...Object.fromEntries(
          Object.entries({ ...nativeSchemas, ...appSettingsSchemas }).map(([name, schema]) => [
            name,
            jsonSchema(schema),
          ]),
        ),
        ErrorEnvelope: jsonSchema(ErrorEnvelopeSchema),
        HealthResponse: jsonSchema(HealthResponseSchema),
        ReadinessResponse: jsonSchema(ReadinessResponseSchema),
        MeResponse: jsonSchema(MeResponseSchema),
        ChildProfile: jsonSchema(ChildProfileSchema),
        CreateChildProfileRequest: jsonSchema(CreateChildProfileRequestSchema),
        CreateChildProfileResponse: jsonSchema(CreateChildProfileResponseSchema),
        ChildProfilePage: jsonSchema(ChildProfilePageSchema),
        UpdateChildProfileRequest: jsonSchema(UpdateChildProfileRequestSchema),
        ChildProfileVersionRequest: jsonSchema(ChildProfileVersionRequestSchema),
        ChildProfileResponse: jsonSchema(ChildProfileResponseSchema),
        WebAuthnCredentialResponse: jsonSchema(WebAuthnCredentialResponseSchema),
        PasskeyRegistrationOptionsRequest: jsonSchema(PasskeyRegistrationOptionsRequestSchema),
        PasskeyAuthenticationOptionsRequest: jsonSchema(PasskeyAuthenticationOptionsRequestSchema),
        PasskeyOptionsResponse: jsonSchema(PasskeyOptionsResponseSchema),
        PasskeyRegistrationVerifyRequest: jsonSchema(PasskeyRegistrationVerifyRequestSchema),
        PasskeyAuthenticationVerifyRequest: jsonSchema(PasskeyAuthenticationVerifyRequestSchema),
        WorkspaceSummary: jsonSchema(WorkspaceSummarySchema),
        AuthenticatedActor: jsonSchema(AuthenticatedActorSchema),
        BrowserSessionResponse: jsonSchema(BrowserSessionResponseSchema),
        ChildSessionRenewResponse: jsonSchema(ChildSessionRenewResponseSchema),
        RecoveryLoginRequest: jsonSchema(RecoveryLoginRequestSchema),
        ChildEnrollmentCreateRequest: jsonSchema(ChildEnrollmentCreateRequestSchema),
        ChildEnrollmentCreateResponse: jsonSchema(ChildEnrollmentCreateResponseSchema),
        ChildEnrollmentRedeemRequest: jsonSchema(ChildEnrollmentRedeemRequestSchema),
        Device: jsonSchema(DeviceSchema),
        DeviceListResponse: jsonSchema(DeviceListResponseSchema),
        DeviceRevokeRequest: jsonSchema(DeviceRevokeRequestSchema),
        UpdateDeviceLabelRequest: jsonSchema(UpdateDeviceLabelRequestSchema),
        PasskeyCredential: jsonSchema(PasskeyCredentialSchema),
        PasskeyCredentialListResponse: jsonSchema(PasskeyCredentialListResponseSchema),
        UpdatePasskeyCredentialRequest: jsonSchema(UpdatePasskeyCredentialRequestSchema),
        WorkspaceMembership: jsonSchema(WorkspaceMembershipSchema),
        WorkspaceMembershipListResponse: jsonSchema(WorkspaceMembershipListResponseSchema),
        WorkspaceMembershipResponse: jsonSchema(WorkspaceMembershipResponseSchema),
        SupporterCapability: jsonSchema(SupporterCapabilitySchema),
        MembershipInvitationScope: jsonSchema(MembershipInvitationScopeSchema),
        MembershipInvitation: jsonSchema(MembershipInvitationSchema),
        MembershipInvitationListResponse: jsonSchema(MembershipInvitationListResponseSchema),
        CreateMembershipInvitationRequest: jsonSchema(CreateMembershipInvitationRequestSchema),
        CreateMembershipInvitationResponse: jsonSchema(CreateMembershipInvitationResponseSchema),
        InspectMembershipInvitationRequest: jsonSchema(InspectMembershipInvitationRequestSchema),
        InspectMembershipInvitationResponse: jsonSchema(InspectMembershipInvitationResponseSchema),
        InvitationPasskeyRegistrationOptionsRequest: jsonSchema(
          InvitationPasskeyRegistrationOptionsRequestSchema,
        ),
        RevokeMembershipInvitationRequest: jsonSchema(RevokeMembershipInvitationRequestSchema),
        UpdateWorkspaceMembershipRequest: jsonSchema(UpdateWorkspaceMembershipRequestSchema),
        TransferWorkspaceOwnershipRequest: jsonSchema(TransferWorkspaceOwnershipRequestSchema),
        LeaveWorkspaceRequest: jsonSchema(LeaveWorkspaceRequestSchema),
        WorkspaceSettings: jsonSchema(WorkspaceSettingsSchema),
        UpdateWorkspaceSettingsRequest: jsonSchema(UpdateWorkspaceSettingsRequestSchema),
        WorkspaceSettingsResponse: jsonSchema(WorkspaceSettingsResponseSchema),
        SuccessResponse: jsonSchema(SuccessResponseSchema),
        CreateAssignedTaskRequest: jsonSchema(CreateAssignedTaskRequestSchema),
        CreateAssignedTaskResponse: jsonSchema(CreateAssignedTaskResponseSchema),
        Area: jsonSchema(AreaSchema),
        AreaListResponse: jsonSchema(AreaListResponseSchema),
        CreateAreaRequest: jsonSchema(CreateAreaRequestSchema),
        UpdateAreaRequest: jsonSchema(UpdateAreaRequestSchema),
        AreaMutationResponse: jsonSchema(AreaMutationResponseSchema),
        AreaArchiveCommandRequest: jsonSchema(AreaArchiveCommandRequestSchema),
        AreaArchiveCommandResponse: jsonSchema(AreaArchiveCommandResponseSchema),
        AreaReorderRequest: jsonSchema(AreaReorderRequestSchema),
        AreaReorderResponse: jsonSchema(AreaReorderResponseSchema),
        Term: jsonSchema(TermSchema),
        TermListResponse: jsonSchema(TermListResponseSchema),
        CreateTermRequest: jsonSchema(CreateTermRequestSchema),
        UpdateTermRequest: jsonSchema(UpdateTermRequestSchema),
        TermMutationResponse: jsonSchema(TermMutationResponseSchema),
        TermArchiveCommandRequest: jsonSchema(TermArchiveCommandRequestSchema),
        TermArchiveCommandResponse: jsonSchema(TermArchiveCommandResponseSchema),
        WorkspaceCalendar: jsonSchema(WorkspaceCalendarSchema),
        WorkspaceCalendarListResponse: jsonSchema(WorkspaceCalendarListResponseSchema),
        CreateWorkspaceCalendarRequest: jsonSchema(CreateWorkspaceCalendarRequestSchema),
        UpdateWorkspaceCalendarRequest: jsonSchema(UpdateWorkspaceCalendarRequestSchema),
        WorkspaceCalendarMutationResponse: jsonSchema(WorkspaceCalendarMutationResponseSchema),
        WorkspaceCalendarArchiveCommandRequest: jsonSchema(
          WorkspaceCalendarArchiveCommandRequestSchema,
        ),
        WorkspaceCalendarArchiveCommandResponse: jsonSchema(
          WorkspaceCalendarArchiveCommandResponseSchema,
        ),
        Notification: jsonSchema(NotificationSchema),
        NotificationListResponse: jsonSchema(NotificationListResponseSchema),
        TaskIconId: jsonSchema(TaskIconIdSchema),
        TaskIconResolution: jsonSchema(TaskIconResolutionSchema),
        TaskIconResolveRequest: jsonSchema(TaskIconResolveRequestSchema),
        TaskIconResolveResponse: jsonSchema(TaskIconResolveResponseSchema),
        DailySummary: jsonSchema(DailySummarySchema),
        DailySummaryResponse: jsonSchema(DailySummaryResponseSchema),
        DailySummarySettingsInput: jsonSchema(DailySummarySettingsInputSchema),
        DailySummarySettingsResponse: jsonSchema(DailySummarySettingsResponseSchema),
        DailySummaryEmailRequest: jsonSchema(DailySummaryEmailRequestSchema),
        DailySummaryEmailConfirm: jsonSchema(DailySummaryEmailConfirmSchema),
        NotificationPreference: jsonSchema(NotificationPreferenceSchema),
        NotificationPreferenceInput: jsonSchema(NotificationPreferenceInputSchema),
        NotificationPreferenceListResponse: jsonSchema(NotificationPreferenceListResponseSchema),
        NotificationPreferenceMutationResponse: jsonSchema(
          NotificationPreferenceMutationResponseSchema,
        ),
        NotificationReadCommandRequest: jsonSchema(NotificationReadCommandRequestSchema),
        NotificationSnoozeCommandRequest: jsonSchema(NotificationSnoozeCommandRequestSchema),
        NotificationCommandResponse: jsonSchema(NotificationCommandResponseSchema),
        WebPushConfigResponse: jsonSchema(WebPushConfigResponseSchema),
        WebPushSubscriptionInput: jsonSchema(WebPushSubscriptionInputSchema),
        WebPushSubscription: jsonSchema(WebPushSubscriptionSchema),
        WebPushSubscriptionResponse: jsonSchema(WebPushSubscriptionResponseSchema),
        WebPushSubscriptionDeleteRequest: jsonSchema(WebPushSubscriptionDeleteRequestSchema),
        Evidence: jsonSchema(EvidenceSchema),
        EvidenceUpload: jsonSchema(EvidenceUploadSchema),
        CreateEvidenceUploadRequest: jsonSchema(CreateEvidenceUploadRequestSchema),
        EvidenceUploadReservationResponse: jsonSchema(EvidenceUploadReservationResponseSchema),
        EvidenceObjectUploadResponse: jsonSchema(EvidenceObjectUploadResponseSchema),
        FinalizeEvidenceUploadRequest: jsonSchema(FinalizeEvidenceUploadRequestSchema),
        CreateNoteEvidenceRequest: jsonSchema(CreateNoteEvidenceRequestSchema),
        EvidenceMutationResponse: jsonSchema(EvidenceMutationResponseSchema),
        EvidenceListResponse: jsonSchema(EvidenceListResponseSchema),
        EvidenceAccessRequest: jsonSchema(EvidenceAccessRequestSchema),
        EvidenceAccessResponse: jsonSchema(EvidenceAccessResponseSchema),
        DeleteEvidenceRequest: jsonSchema(DeleteEvidenceRequestSchema),
        DashboardRate: jsonSchema(DashboardRateSchema),
        DashboardTaskBreakdown: jsonSchema(DashboardTaskBreakdownSchema),
        DashboardDailyLoad: jsonSchema(DashboardDailyLoadSchema),
        DashboardRoutineTrend: jsonSchema(DashboardRoutineTrendSchema),
        DashboardProjectProgress: jsonSchema(DashboardProjectProgressSchema),
        DashboardTermProgress: jsonSchema(DashboardTermProgressSchema),
        DashboardHighlight: jsonSchema(DashboardHighlightSchema),
        DashboardResponse: jsonSchema(DashboardResponseSchema),
        SearchContentItem: jsonSchema(SearchContentItemSchema),
        SearchContentPageResponse: jsonSchema(SearchContentPageResponseSchema),
        ProductHistoryItem: jsonSchema(ProductHistoryItemSchema),
        ProductHistoryPageResponse: jsonSchema(ProductHistoryPageResponseSchema),
        SecurityAuditItem: jsonSchema(SecurityAuditItemSchema),
        SecurityAuditPageResponse: jsonSchema(SecurityAuditPageResponseSchema),
        CreateWorkspaceExportRequest: jsonSchema(CreateWorkspaceExportRequestSchema),
        DeleteWorkspaceExportRequest: jsonSchema(DeleteWorkspaceExportRequestSchema),
        WorkspaceExportResponse: jsonSchema(WorkspaceExportResponseSchema),
        WorkspaceExportListResponse: jsonSchema(WorkspaceExportListResponseSchema),
        ChildCycleCommitment: jsonSchema(ChildCycleCommitmentSchema),
        ChildCurrentFamilyCycle: jsonSchema(ChildCurrentFamilyCycleSchema),
        ChildCurrentFamilyCycleResponse: jsonSchema(ChildCurrentFamilyCycleResponseSchema),
        FamilyCycle: jsonSchema(FamilyCycleSchema),
        FamilyCycleListResponse: jsonSchema(FamilyCycleListResponseSchema),
        FamilyCycleResponse: jsonSchema(FamilyCycleResponseSchema),
        CreateFamilyCycleRequest: jsonSchema(CreateFamilyCycleRequestSchema),
        UpdateFamilyCyclePlanRequest: jsonSchema(UpdateFamilyCyclePlanRequestSchema),
        UpdateFamilyCycleReviewRequest: jsonSchema(UpdateFamilyCycleReviewRequestSchema),
        FamilyCycleMutationResponse: jsonSchema(FamilyCycleMutationResponseSchema),
        FamilyCycleCommandRequest: jsonSchema(FamilyCycleCommandRequestSchema),
        FamilyCycleCommandResponse: jsonSchema(FamilyCycleCommandResponseSchema),
        ApplyReviewActionRequest: jsonSchema(ApplyReviewActionRequestSchema),
        DismissReviewActionRequest: jsonSchema(DismissReviewActionRequestSchema),
        ReviewActionCommandResponse: jsonSchema(ReviewActionCommandResponseSchema),
        Project: jsonSchema(ProjectSchema),
        CreateProjectRequest: jsonSchema(CreateProjectRequestSchema),
        CreateProjectResponse: jsonSchema(CreateProjectResponseSchema),
        ProjectListResponse: jsonSchema(ProjectListResponseSchema),
        UpdateProjectRequest: jsonSchema(UpdateProjectRequestSchema),
        UpdateProjectResponse: jsonSchema(UpdateProjectResponseSchema),
        ProjectArchiveCommandRequest: jsonSchema(ProjectArchiveCommandRequestSchema),
        ProjectArchiveCommandResponse: jsonSchema(ProjectArchiveCommandResponseSchema),
        Milestone: jsonSchema(MilestoneSchema),
        CreateMilestoneRequest: jsonSchema(CreateMilestoneRequestSchema),
        CreateMilestoneResponse: jsonSchema(CreateMilestoneResponseSchema),
        MilestoneCommandRequest: jsonSchema(MilestoneCommandRequestSchema),
        MilestoneCommandResponse: jsonSchema(MilestoneCommandResponseSchema),
        TodayTask: jsonSchema(TodayTaskSchema),
        CarryoverTask: jsonSchema(CarryoverTaskSchema),
        CarryoverTaskListResponse: jsonSchema(CarryoverTaskListResponseSchema),
        ScheduledTask: jsonSchema(ScheduledTaskSchema),
        TaskListResponse: jsonSchema(TaskListResponseSchema),
        BacklogTaskListResponse: jsonSchema(BacklogTaskListResponseSchema),
        TodayTaskListResponse: jsonSchema(TodayTaskListResponseSchema),
        TodayTaskReorderRequest: jsonSchema(TodayTaskReorderRequestSchema),
        TodayTaskReorderResponse: jsonSchema(TodayTaskReorderResponseSchema),
        TaskCommandRequest: jsonSchema(TaskCommandRequestSchema),
        TaskCommandResponse: jsonSchema(TaskCommandResponseSchema),
        RescheduleTaskRequest: jsonSchema(RescheduleTaskRequestSchema),
        RescheduleTaskResponse: jsonSchema(RescheduleTaskResponseSchema),
        UpdateTaskRequest: jsonSchema(UpdateTaskRequestSchema),
        UpdateTaskResponse: jsonSchema(UpdateTaskResponseSchema),
        TaskChecklistItem: jsonSchema(TaskChecklistItemSchema),
        TaskDependency: jsonSchema(TaskDependencySchema),
        TaskStructure: jsonSchema(TaskStructureSchema),
        TaskStructureResponse: jsonSchema(TaskStructureResponseSchema),
        CreateTaskChecklistItemRequest: jsonSchema(CreateTaskChecklistItemRequestSchema),
        UpdateTaskChecklistItemRequest: jsonSchema(UpdateTaskChecklistItemRequestSchema),
        TaskChecklistItemCommandRequest: jsonSchema(TaskChecklistItemCommandRequestSchema),
        TaskChecklistItemMutationResponse: jsonSchema(TaskChecklistItemMutationResponseSchema),
        CreateTaskDependencyRequest: jsonSchema(CreateTaskDependencyRequestSchema),
        OverrideTaskDependencyRequest: jsonSchema(OverrideTaskDependencyRequestSchema),
        RemoveTaskDependencyRequest: jsonSchema(RemoveTaskDependencyRequestSchema),
        TaskDependencyMutationResponse: jsonSchema(TaskDependencyMutationResponseSchema),
        InboxItem: jsonSchema(InboxItemSchema),
        CreateInboxItemRequest: jsonSchema(CreateInboxItemRequestSchema),
        CreateInboxItemResponse: jsonSchema(CreateInboxItemResponseSchema),
        InboxItemListResponse: jsonSchema(InboxItemListResponseSchema),
        PlanInboxItemRequest: jsonSchema(PlanInboxItemRequestSchema),
        PlanInboxItemResponse: jsonSchema(PlanInboxItemResponseSchema),
        CancelInboxItemRequest: jsonSchema(CancelInboxItemRequestSchema),
        CancelInboxItemResponse: jsonSchema(CancelInboxItemResponseSchema),
        Routine: jsonSchema(RoutineSchema),
        RoutineListResponse: jsonSchema(RoutineListResponseSchema),
        RoutineReconciliationListResponse: jsonSchema(RoutineReconciliationListResponseSchema),
        RoutineReconciliationRequest: jsonSchema(RoutineReconciliationRequestSchema),
        RoutineReconciliationResponse: jsonSchema(RoutineReconciliationResponseSchema),
        RoutineCreatePreviewRequest: jsonSchema(RoutineCreatePreviewRequestSchema),
        RoutineCreatePreviewResponse: jsonSchema(RoutineCreatePreviewResponseSchema),
        RoutineCreateApplyRequest: jsonSchema(RoutineCreateApplyRequestSchema),
        RoutineCreateApplyResponse: jsonSchema(RoutineCreateApplyResponseSchema),
        RoutineVersionHistoryResponse: jsonSchema(RoutineVersionHistoryResponseSchema),
        RoutineVersionComparisonResponse: jsonSchema(RoutineVersionComparisonResponseSchema),
        RoutineStatusCommandRequest: jsonSchema(RoutineStatusCommandRequestSchema),
        RoutineStatusCommandResponse: jsonSchema(RoutineStatusCommandResponseSchema),
        RoutineUpdatePreviewRequest: jsonSchema(RoutineUpdatePreviewRequestSchema),
        RoutineUpdatePreviewResponse: jsonSchema(RoutineUpdatePreviewResponseSchema),
        RoutineUpdateApplyRequest: jsonSchema(RoutineUpdateApplyRequestSchema),
        RoutineUpdateApplyResponse: jsonSchema(RoutineUpdateApplyResponseSchema),
        RoutineTemplate: jsonSchema(RoutineTemplateSchema),
        CreateRoutineTemplateRequest: jsonSchema(CreateRoutineTemplateRequestSchema),
        UpdateRoutineTemplateRequest: jsonSchema(UpdateRoutineTemplateRequestSchema),
        RoutineTemplateListResponse: jsonSchema(RoutineTemplateListResponseSchema),
        RoutineTemplateMutationResponse: jsonSchema(RoutineTemplateMutationResponseSchema),
        RoutineTemplateArchiveCommandRequest: jsonSchema(
          RoutineTemplateArchiveCommandRequestSchema,
        ),
        RoutineTemplateArchiveCommandResponse: jsonSchema(
          RoutineTemplateArchiveCommandResponseSchema,
        ),
        StagingRuntimeProofRequest: jsonSchema(StagingRuntimeProofRequestSchema),
        StagingRuntimeProofResponse: jsonSchema(StagingRuntimeProofResponseSchema),
        BackgroundJobResponse: jsonSchema(BackgroundJobResponseSchema),
        OAuthClientRegistrationRequest: jsonSchema(OAuthClientRegistrationRequestSchema),
        OAuthClientRegistrationResponse: jsonSchema(OAuthClientRegistrationResponseSchema),
        OAuthAuthorizationRequestCreate: jsonSchema(OAuthAuthorizationRequestCreateSchema),
        OAuthAuthorizationRequestCreateResponse: jsonSchema(
          OAuthAuthorizationRequestCreateResponseSchema,
        ),
        OAuthConsentRequest: jsonSchema(OAuthConsentRequestSchema),
        OAuthConsentResponse: jsonSchema(OAuthConsentResponseSchema),
        OAuthConsentApproveRequest: jsonSchema(OAuthConsentApproveRequestSchema),
        OAuthConsentApproveResponse: jsonSchema(OAuthConsentApproveResponseSchema),
        OAuthTokenResponse: jsonSchema(OAuthTokenResponseSchema),
        McpActorResponse: jsonSchema(McpActorResponseSchema),
        McpToolAuditRequest: jsonSchema(McpToolAuditRequestSchema),
        McpResourceAuditRequest: jsonSchema(McpResourceAuditRequestSchema),
        McpBulkReschedulePreviewRequest: jsonSchema(McpBulkReschedulePreviewRequestSchema),
        McpBulkReschedulePreviewResponse: jsonSchema(McpBulkReschedulePreviewResponseSchema),
        McpBulkRescheduleApplyRequest: jsonSchema(McpBulkRescheduleApplyRequestSchema),
        McpBulkRescheduleApplyResponse: jsonSchema(McpBulkRescheduleApplyResponseSchema),
        AgentGrant: jsonSchema(AgentGrantSchema),
        AgentGrantListResponse: jsonSchema(AgentGrantListResponseSchema),
        AgentGrantRevokeRequest: jsonSchema(AgentGrantRevokeRequestSchema),
      },
    },
  };
}
